import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";

export function useFavorites(user) {
  const [favs, setFavs] = useState([]);

  useEffect(() => {
    if (!user) { setFavs([]); return; }
    api.get("/me/favorite-ids").then(({ data }) => setFavs(data)).catch(() => {});
  }, [user]);

  const toggle = useCallback(async (id) => {
    if (favs.includes(id)) {
      await api.delete(`/listings/${id}/favorite`);
      setFavs((p) => p.filter((x) => x !== id));
    } else {
      await api.post(`/listings/${id}/favorite`);
      setFavs((p) => [...p, id]);
    }
  }, [favs]);

  return { favs, toggle: user ? toggle : null };
}
